import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-wf-summary",
  "use": "icon-soc-wf-summary-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-wf-summary\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<rect x=\"192\" y=\"192\" width=\"640\" height=\"640\" rx=\"40\" /><path d=\"M288 320h448v48H288zM288 416h448v48H288zM288 512h320v48H288zM288 608h384v48H288z\" fill=\"#fff\" /><circle cx=\"736\" cy=\"632\" r=\"48\" fill=\"#fff\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-wf-summary.svg
// module id = h/yl
// module chunks = 488